
/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import AccessControl from "../functional/AccessControl";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import { debounce } from "lodash";
import getSchema from '../../lib/api/getSchema';
import TkElectrodeOrderPurchaseDetailCreateButton from './../input/TkElectrodeOrderPurchaseDetailCreateButton';

function TkElectrodeOrderPurchaseDetail(props) {

    const id = "TkElectrodeOrderPurchaseDetail"

    const table = "TkElectrodeOrderPurchaseDetail"

    const view = "TkVwElectrodeOrderPurchaseDetail"

    const { onSelectMst, onSelectOrderBuy } = props;
    const [grid, setGrid] = useState();

    // const [onSelectDetail, setOnSelectDetail] = useState();

    const { t } = useTranslation();

    const [schema, setSchema] = useState();

    const [api, setApi] = useState();

    const [disabled, setDisabled] = useState(false);

    const [isEmpty, setIsEmpty] = useState();


    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {

        (async () => {

            let schema = await getSchema("TkElectrodeOrderPurchaseDetail");

            for (const column of schema.columns) {

                switch (column.name) {

                    case "electrodeId":

                        column.defaultValue = onSelectMst?.electrodeId;
                        column.disabled = true;

                        break;

                    default:

                        break;
                }
            }

            setSchema(schema);

            if (api) {

                api.refresh();

            }

        })();

        if (onSelectMst?.electrodeId && onSelectOrderBuy?.orderBuyerDetailId) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

    }, [onSelectMst?.electrodeId, onSelectOrderBuy?.orderBuyerDetailId]);

    // useEffect(() => {

    //     (async () => {

    //         if (grid) {

    //             grid.selectionChanged.addHandler(debounce((grid, event) => {

    //                 if (grid.selectedItems && grid.selectedItems[0]) {

    //                     setOnSelectDetail(grid.selectedItems[0])

    //                 } else {

    //                     setOnSelectDetail([]);

    //                 };

    //             }), 10);

    //             grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

    //                 if (grid.selectedItems && grid.selectedItems[0]) {

    //                     setOnSelectDetail(grid.selectedItems[0])

    //                 } else {

    //                     setOnSelectDetail([]);

    //                 };

    //             }), 10);
    //         }

    //     })()

    // }, [grid])

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    }

    const onInitialized = grid => {

        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

    const onModifyViewUrl = (url) => {
        return url + "/" + onSelectMst?.electrodeId + "/" + onSelectOrderBuy?.orderBuyerDetailId;
    }

    return (
        <>


            <BasicCrudScreenType
                id={id}
                headerTitle={t("term.tkElectrodeOrderPurchaseDetail")}
                table={table}
                view={view}
                onInitialized={onInitialized}
                onApiInitialized={onApiInitialized}
                onLoadData={onLoadData}
                exportFormatItem={() => { }}
                noCreate
                noEdit
                noDelete
                noExcel
                onModifyViewUrl={onModifyViewUrl}
                onAppendButtonInFrontOfSearch={
                    () => (
                        <>
                            <BasicCrudScreenActionItemLayout>

                                <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                    <TkElectrodeOrderPurchaseDetailCreateButton
                                        id={id}
                                        schema={schema}
                                        refresh={api}
                                        onSuccess={onSuccess}
                                        electrodeId={onSelectMst?.electrodeId}
                                        onSelectOrderBuy={onSelectOrderBuy}
                                        disabled={disabled}
                                    />
                                </AccessControl>

                                <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch ? "PATCH" : "PUT")}>
                                    <UpdateRecordButton
                                        id={id}
                                        schema={schema}
                                        grid={grid}
                                        refresh={api}
                                        disabled={isEmpty}
                                        onSuccess={onSuccess}
                                    />
                                </AccessControl>

                                <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                                    <DeleteRecordButton
                                        id={id}
                                        schema={schema}
                                        grid={grid}
                                        refresh={api}
                                        color="secondary"
                                        disabled={isEmpty}
                                        onSuccess={onSuccess}
                                        onFailure={onFailure}
                                        onPartialFailure={onNotifyWarning}
                                    />
                                </AccessControl>

                                <AccessControl accessTarget={schema && schema.name} accessMethod="SAVETOEXCEL">
                                    <SaveToExcelButton
                                        id={id}
                                        grid={grid}
                                        view={view}
                                        color="primary"
                                        exportFormatItem={() => { }}
                                        disabled={isEmpty}
                                    />
                                </AccessControl>
                            </BasicCrudScreenActionItemLayout>
                        </>
                    )
                }
            />

        </>

    );

}

export default TkElectrodeOrderPurchaseDetail;
